<ng-container [ngSwitch]="state">
    <div class="state state-pending" *ngSwitchCase="POD_STATE.PENDING">
        <span [i18n]="'pods-validation.state.pending'"></span>
    </div>
    <div class="state state-review" *ngSwitchCase="POD_STATE.CHEP_REVIEW">
        <span [i18n]="'pods-validation.state.chep-review'"></span>
    </div>
    <div class="state state-validated" *ngSwitchCase="POD_STATE.VALIDATED">
        <span [i18n]="'pods-validation.state.validated'"></span>
    </div>
</ng-container>
